import { CarrierNumberFormat } from './carrier-number-format.enum';

export const CARRIER_NUMBER_FORMAT_OPTIONS: { value: CarrierNumberFormat; label: string }[] = [
  {
    value: CarrierNumberFormat.National,
    label: 'Settings::PhoneNumbers:CarrierNumberFormat:National',
  },
  {
    value: CarrierNumberFormat.E164,
    label: 'Settings::PhoneNumbers:CarrierNumberFormat:E164',
  },
  {
    value: CarrierNumberFormat.InternationalWithoutPlus,
    label: 'Settings::PhoneNumbers:CarrierNumberFormat:InternationalWithoutPlus',
  },
];
